import * as React from "react";
import { useDispatch } from "react-redux";
import { getStatusHistory } from "../actions";

export const HistoryGridTemplate = ({cell}) => {
    const { rowId } = cell;
    
    const dispatch = useDispatch();

    const handleHistory = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
		dispatch({ type: 'TOGGLE_HISTORY_MODAL', payload: true });
        dispatch({ type: 'SET_ROW_ID', payload: rowId });
        getStatusHistory(rowId)(dispatch);
    };

    return (
        <div className="btn-group-vertical" role="group" style={{ width: "100%" }}>
            <button
                className="btn btn-success"
                onClick={handleHistory}
                title="История изменений"
            >
                История
            </button>
        </div>
    );
};
